import axios from "axios";

export default async function removeProjectUser(projectName, user) {
    await axios.patch(`/project/${projectName}/remove-user`, {
        "username": user
    })
}